import styled from 'styled-components'

export const FieldsGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 1rem;
  margin-bottom: 1.5rem;
`

export const FieldItem = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.25rem;
`

export const FieldLabel = styled.span`
  font-size: 12px;
  font-weight: 700;
  color: #696969;
`

export const FieldValue = styled.span`
  font-size: 15px;
  color: #333;
  word-break: break-word;
`

export const StructuresList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1rem;
`

export const StructureCard = styled.div`
  background-color: #f4f4f4;
  border-radius: 0.75rem;
  padding: 1rem;
`

export const StructureTitle = styled.h3`
  margin: 0 0 0.75rem;
  font-size: 15px;
  font-weight: 700;
  color: #333;
`

export const ColumnsTable = styled.div`
  display: grid;
  grid-template-columns: 2fr 1fr 1fr;
  gap: 0.5rem;
`

export const ColumnHeader = styled.span`
  font-size: 12px;
  font-weight: 700;
  color: #696969;
`

export const ColumnCell = styled.span`
  font-size: 14px;
  color: #333;
`

export const EmptyState = styled.p`
  margin: 0;
  font-size: 14px;
  color: #696969;
`
